import { Routes } from '@angular/router';
import { NotFoundComponent } from './features/not-found/not-found.component';
import { HomeComponent } from './features/home/home.component';
import { LoginComponent } from './features/login/login.component';
import { InternoKcLoginComponent } from './features/login/interno-kc-login.component';
import { CallbackComponent } from './features/callback/callback.component';
import { SemAcessoComponent } from './features/sem-acesso/sem-acesso.component';
import { AuthGuard } from './core/guards/auth.guard';
import { LoginGuard } from './core/guards/login.guard';
import { aceiteTermosGuard } from './core/guards/aceite-termos.guard';
import { servicoRadioterapiaCnesContextoGuard } from './features/servico-radioterapia/guards/servico-radioterapia-cnes-contexto.guard';
import { RECURSO_EM_DESENVOLVIMENTO_SEGMENT } from './core/guards/recurso-em-desenvolvimento.guard';

export const routes: Routes = [
  // ── Rotas sem layout (login, callbacks, estados especiais) ──────────────
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'login-interno-kc',
    component: InternoKcLoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'auth/callback',
    component: CallbackComponent,
  },
  {
    path: 'sem-acesso',
    component: SemAcessoComponent,
  },
  {
    // HU-00 — aceite dos Termos de Uso: fora do shell, sem o aceiteTermosGuard.
    path: 'termos',
    loadComponent: () =>
      import('./features/termos/pages/termos.component').then((m) => m.TermosComponent),
    canActivate: [AuthGuard],
  },
  // ── Shell com layout (rotas protegidas) ─────────────────────────────────
  {
    path: '',
    loadComponent: () =>
      import('./core/layout/layout.component').then((m) => m.LayoutComponent),
    canActivate: [AuthGuard],
    // aceiteTermosGuard antes do contexto CNES (D-01 / OQ-04: aceite vem primeiro).
    canActivateChild: [aceiteTermosGuard, servicoRadioterapiaCnesContextoGuard],
    children: [
      {
        path: '',
        component: HomeComponent,
        data: { breadcrumb: [{ label: 'Início' }] },
      },
      {
        path: 'home',
        component: HomeComponent,
        data: { breadcrumb: [{ label: 'Início' }] },
      },
      {
        path: RECURSO_EM_DESENVOLVIMENTO_SEGMENT,
        loadComponent: () =>
          import('./features/desenvolvimento/recurso-em-desenvolvimento.component').then(
            (m) => m.RecursoEmDesenvolvimentoComponent,
          ),
        data: {
          breadcrumb: [
            { label: 'Início', route: '/home' },
            { label: 'Em desenvolvimento' },
          ],
        },
      },
      // Feature: Serviço de radioterapia (onboarding)
      {
        path: '',
        loadChildren: () =>
          import('./features/servico-radioterapia/servico-radioterapia.routes').then((m) => m.servicoRadioterapiaRoutes),
      },
      {
        path: '',
        loadChildren: () =>
          import('./features/identidade-usuarios/identidade-usuarios.routes').then(
            (m) => m.identidadeUsuariosRoutes,
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./features/gestao-federal/gestao-federal.routes').then((m) => m.gestaoFederalRoutes),
      },
      {
        path: '',
        loadChildren: () =>
          import('./features/incrementos/incrementos.routes').then((m) => m.incrementosRoutes),
      },
      {
        path: '',
        loadChildren: () =>
          import('./features/dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
      },
      {
        path: '',
        loadChildren: () =>
          import('./features/relatorios/relatorios.routes').then((m) => m.relatoriosRoutes),
      },
    ],
  },

  {
    path: '**',
    component: NotFoundComponent,
  },
];
